/**
 * Global namespace for most components `container` option.
 */
const dataBsContainer = 'data-bs-container';
export default dataBsContainer;
